export const AUTH_LOGIN = 'auth/login';
export const AUTH_LOGIN_WITH_SESSION_TOKEN = 'auth/loginWithSessionToken';
export const USER_HYDRATE_FROM_COOKIE = 'auth/userHydrateFromCookie';

export const ERROR_INVALID_CREDENTIALS = 'Invalid credentials';
export const ERROR_FAILED_AUTHENTICATE_USER = 'Failed to authenticate user';
export const ERROR_NO_SESSION_TOKEN = 'No session token found';
export const ERROR_MISSING_FLOW_ID = 'Missing flow ID';
export const ERROR_FAILED_TO_FETCH_DEVICES = 'Failed to fetch devices';
export const ERROR_FAILED_TO_AUTHORIZE_MFA = 'Failed to authorize MFA';
export const ERROR_FAILED_TO_ADD_DEVICE = 'Failed to add device';
export const ERROR_FAILED_TO_REMOVE_DEVICE = 'Failed to remove device';
export const ERROR_FAILED_TO_VERIFY_OTP = 'Failed to verify OTP';
export const ERROR_FAILED_TO_VERIFY_EMAIL = 'Failed to verify email';
export const ERROR_FAILED_TO_VERIFY_PHONE = 'Failed to verify phone';
export const ERROR_FAILED_TO_VERIFY_PASSWORD = 'Failed to verify password';
